export const DEVICE_LABEL_KEYS = {
  mobile: 'linkClicks.deviceMobile',
  desktop: 'linkClicks.deviceDesktop',
  tablet: 'linkClicks.deviceTablet',
  other: 'linkClicks.deviceOther'
};

export const DEVICE_COLORS = {
  mobile: '#3a83f6',
  desktop: '#0c3f90',
  tablet: '#276ad4',
  other: '#8b929a'
};
